(function () {
  "use strict";
  if (window.kibraProductSizeLabelsReady) return;
  window.kibraProductSizeLabelsReady = true;

  const SELECTOR = ".selector-wrapper--size[data-size-label-map]";

  function getDisplayValue(wrapper, rawValue) {
    if (!rawValue) return rawValue;

    try {
      const map = JSON.parse(wrapper.getAttribute("data-size-label-map"));
      return map[rawValue] || rawValue;
    } catch (error) {
      return rawValue;
    }
  }

  function updateSizeLabel(wrapper, rawValue) {
    const label = wrapper.querySelector("[data-option-value]");

    if (!label || !rawValue) return;

    label.textContent = getDisplayValue(wrapper, rawValue);
  }

  function updateSizeLabels(root = document) {
    root.querySelectorAll(SELECTOR).forEach((wrapper) => {
      const label = wrapper.querySelector("[data-option-value]");

      if (!label) return;

      updateSizeLabel(wrapper, label.textContent.trim());
    });
  }

  function init(root = document) {
    updateSizeLabels(root);
  }

  document.addEventListener("theme:variant:change", (event) => {
    const variant = event.detail?.variant;

    if (!variant) return;

    document.querySelectorAll(SELECTOR).forEach((wrapper) => {
      const optionPosition = parseInt(
        wrapper.getAttribute("data-option-position"),
        10,
      );
      const rawValue = variant.options[optionPosition - 1];

      updateSizeLabel(wrapper, rawValue);
    });
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target);
  });
})();
